import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {TeVariableProviderService} from "./interfaces/te-variable-provider.service";
import {TeContentProviderVariableDto} from "../../model/dto/api/te.content-provider-variable.dto";
import {Observable} from "rxjs";
import {MetaDataEntityDto} from "../../../../core/shared/meta/dto/meta-data-entity.dto";

@Injectable({
  providedIn: 'root'
})
export class TeTemplateVariableService extends MvsCrudService implements TeVariableProviderService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/te/teTemplateVariables');
  }

  /**
   * Return variables.
   * @param contentProviderId
   */
  listVariables(contentProviderId: number): Observable<TeContentProviderVariableDto[]> {
    return this.http.get<TeContentProviderVariableDto[]>(`${this.apiUrl}/variables/${contentProviderId}`);
  }

  expandSystemVariables(alias: string): Observable<MetaDataEntityDto> {
    return this.http.get<MetaDataEntityDto>(`${this.apiUrl}/variables/expand/${alias}`);
  }

  searchVariables(templateId: number, query: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/search/${templateId}?query=${encodeURIComponent(query)}`);
  }

}
